import { DEFAULT_CURRENCY_SELECTOR_MODAL_CURRENCIES } from "@/components/CurrencySelector/constants";
import { DEFAULT_CURRENCY } from "./constants";

const DROPDOWN_CURRENCY_CODES = new Set(
  DEFAULT_CURRENCY_SELECTOR_MODAL_CURRENCIES.map((currency) => currency.code),
);

const COUNTRY_TO_CURRENCY: Record<string, string> = {
  AU: "AUD",
  BR: "BRL",
  CA: "CAD",
  CH: "CHF",
  CN: "CNY",
  GB: "GBP",
  IN: "INR",
  JP: "JPY",
  KR: "KRW",
  MX: "MXN",
  SG: "SGD",
  US: "USD",
  ZA: "ZAR",
};

const EUROZONE_COUNTRIES = new Set([
  "AT",
  "BE",
  "CY",
  "DE",
  "EE",
  "ES",
  "FI",
  "FR",
  "GR",
  "HR",
  "IE",
  "IT",
  "LT",
  "LU",
  "LV",
  "MT",
  "NL",
  "PT",
  "SI",
  "SK",
]);

export const getCurrencyForCountry = (countryCode: string): string => {
  const country = countryCode.trim().toUpperCase();

  const mappedCurrency =
    COUNTRY_TO_CURRENCY[country] ??
    (EUROZONE_COUNTRIES.has(country) ? "EUR" : DEFAULT_CURRENCY);

  return DROPDOWN_CURRENCY_CODES.has(mappedCurrency)
    ? mappedCurrency
    : DEFAULT_CURRENCY;
};
